var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{ref:"tcPlayer",staticStyle:{"width":"100%","height":"auto"},attrs:{"id":"id_test_video"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }